import {
  Link,
  useNavigate,
  useParams,
  useLoaderData,
} from "react-router-dom";
import { useState, useEffect } from "react";

import { VispsicologicasUpdate } from "./VispsicologicasUpdate";
import { VispsicologicasDelete } from "./VispsicologicasDelete";

import * as APITRATAMIENTO from "../services/tratamientos";

export function VispsicologicasEdit(props) {
  const vispsicologicas = useLoaderData();
  const navigate = useNavigate();
  const errorMessage = vispsicologicas.message;

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);
  const [permisoTemporalPsicohosp, setPermisoTemporalPsicohosp] = useState(false);


  const [vispsicResp, setVispsicResp] = useState(vispsicologicas.meta?.vispsicResp);
  const [vispsicFecha, setVispsicFecha] = useState(vispsicologicas.meta?.metaFecha);
  const vispsicHora = vispsicologicas.meta?.vispsicHora;
  // const [vispsicHora, setVispsicHora] = useState(vispsicologicas.meta?.vispsicHora);
  const [vispsicObs, setVispsicObs] = useState(vispsicologicas.meta?.vispsicObs);
  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();
  let vispsicologicasId = vispsicologicas.id;

  const vispsicDate = new Date(vispsicologicas.date);
  const diffDate = (Math.abs(new Date() - vispsicDate) / 36e5);

  useEffect(() => {
    const loadTratamientoData = async () => {
      // Obtener los datos del tratamiento
      const tratamiento = await APITRATAMIENTO.getTratamientoById(tratamientoId);

      // Verificar si el especialistaId está en meta.psicohosp
      const permiso = tratamiento.meta.psicohosp.some(
        (psicologo) => {
          return psicologo.value === props.especialistaId;
        }
      );
  
      // Guardar el resultado en el estado
      setPermisoTemporalPsicohosp(permiso);
    };
  
    loadTratamientoData();
  }, [tratamientoId, props.especialistaId]);

  const submitVispsicologicas = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    try {
      await VispsicologicasUpdate(
        vispsicResp,
        vispsicFecha,
        vispsicHora,
        vispsicObs,
        tratamientoId,
        pacienteId,
        vispsicologicasId
         ).then(
        (val) => {
          navigate(`../${tratamientoId}/hospitalizacion/visitas-psicologicas/${vispsicologicasId}`);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  const deleteItem = async (e) => {
    e.preventDefault();
    setIsDeletingButton(true);
    try {
      await VispsicologicasDelete(
        vispsicologicasId
      ).then(
        (val) => {
          window.location.replace("../");
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
    <div id="content">
      {vispsicologicas.length === 0 ? (
        <div>Cargando...</div>
      ) : (
        errorMessage? (
          <p>{errorMessage}</p>
        ) : (
      <form id="formUpdatelement" onSubmit={submitVispsicologicas}>
        <fieldset id="disabledContainer">
        <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='vispsicResp'>Responsable</label>
              <div className='control'>
                <input
                  className='input'
                  id='vispsicResp'
                  required
                  type='text'
                  value={vispsicResp}
                  onChange={(e) => setVispsicResp(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='vispsicFecha'>Fecha visita</label>
              <div className='control'>
                <input
                  className='input'
                  id='vispsicFecha'
                  required
                  type='date'
                  value={vispsicFecha}
                  onChange={(e) => setVispsicFecha(e.target.value)}
                />
              </div>
            </div>
            {/* <div className='field'>
              <label htmlFor='vispsicHora'>Hora de Visita</label>
              <div className='control'>
                <input
                  className='input'
                  id='vispsicHora'
                  required
                  type='time'
                  value={vispsicHora}
                  onChange={(e) => setVispsicHora(e.target.value)}
                />
              </div>
            </div> */}
          </div>
          <div className='field'>
            <label htmlFor='vispsicoObs'>Observaciones</label>
            <div className='control'>
              <textarea
                className='textarea'
                name='vispsicoObs'
                id='vispsicoObs'
                value={vispsicObs}
                onChange={(e) => setVispsicObs(e.target.value)}
              ></textarea>
            </div>
          </div>

      </fieldset>
      </form>
      ))}
      </div>
      {!errorMessage &&
      <div id='actions'>
      {((diffDate <= 72 && props.userRole.includes('psicologia-hospital')) || (props.userRole.includes('administrador')) || (diffDate <= 72 && permisoTemporalPsicohosp))  && (
        <button
          className='button is-link'
          id='saveButton'
          form='formUpdatelement'
          type='submit'
          disabled={isCreatingButton}
        >
          {isCreatingButton ? <div className="spinner"></div> : 'Guardar'}
        </button>
        )}
        <Link
          className='button is-link is-light'
          to={`../${tratamientoId}/hospitalizacion/visitas-psicologicas/${vispsicologicas.id}`}
        >
          Cancelar
        </Link>
        {(props.userRole.includes('administrador'))  &&
        <button 
        className="button is-danger" 
        id="deleteButton" 
        onClick={deleteItem}
        disabled={isDeletingButton}
        >
        {isDeletingButton ? <div className="spinner"></div> : 'Eliminar'}
        </button>
        }
      </div>
      }
    </>
  );
}
